import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Component({
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent {
    @Input() public backLink: string;

    constructor(private location: Location, private localize: LocalizeRouterService, private router: Router) {}

    public back(): void {
        if (this.backLink) {
            this.router.navigate([this.localize.translateRoute(this.backLink)]);
        } else {
            this.location.back();
        }
    }
}
